var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:_vm.classes,attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.loading ? _vm.loadingLabel : _vm.label)+"\n  ")]},{"download":_vm.download,"loading":_vm.loading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }